import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { API_URL, LIVE } from '../../common/variables';

const requestMerchants = createAsyncThunk(
  'REQUEST_MERCHANTS',
  async (arg = null, { getState, rejectWithValue }) => {
    try {
      const state = getState();

      let res = await fetch(API_URL + '/merchants/search-auth', {
        body: JSON.stringify({ live: LIVE, filter: { userIsOwner: true } }),
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${state.app.token}`,
          'Content-Type': 'application/json',
        },
        method: 'POST',
      });
      if (res.status === 200) {
        let result = await res.json();
        return result[0];
      } else return rejectWithValue(res.status);
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);

const merchantsSlice = createSlice({
  name: 'merchants',
  initialState: {
    isFetchingMerchants: false,
    isIndexed: false,
    items: [],
    errorFetchingMerchants: false,
  },
  reducers: {},
  extraReducers: {
    [requestMerchants.pending]: (state) => {
      state.isFetchingMerchants = true;
    },
    [requestMerchants.fulfilled]: (state, action) => {
      state.isFetchingMerchants = false;
      state.items = action.payload;
    },
    [requestMerchants.rejected]: (state, action) => {
      state.errorFetchingMerchants = action.payload;
    },
  },
});

export { requestMerchants };

export default merchantsSlice.reducer;
